import parseYoutubeURL from '../../../../utils/parseYoutubeURL';
import { LinkUserMaterial } from '../../_api/UserMaterialApi';
import { Node } from '../../_api/TableOfContentsApi';
import UserMaterialContentType from '../../_components/common/UserMaterialContentType';
import EmbeddableMediaModal from '../../_modals/EmbeddableMediaModal';

export default function useLinkUserMaterial() {
  function openLinkUserMaterial(material: LinkUserMaterial, node: Node) {
    const parsedYoutubeURL = parseYoutubeURL(material.href);

    if (parsedYoutubeURL) {
      return (
        <EmbeddableMediaModal
          node={node}
          url={parsedYoutubeURL}
          name={material.name}
          id="embeddable-media-modal"
          contentType={<UserMaterialContentType />}
        />
      );
    }
  }

  return {
    openLinkUserMaterial,
  };
}
